import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

// Utility functions for managing cart items in sessionStorage

export const CART_STORAGE_KEY = 'rentAnything_cart';
export const BILLING_INFO_STORAGE_KEY = 'rentAnything_billingInfo';

export const getCartFromSession = () => {
    if (typeof window === 'undefined') return null;
    const cartData = window.sessionStorage.getItem(CART_STORAGE_KEY);
    return cartData ? JSON.parse(cartData) : null;
};

export const saveCartToSession = (cartData) => {
    if (typeof window === 'undefined') return;
    window.sessionStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cartData));
};

export const clearCartFromSession = () => {
    if (typeof window === 'undefined') return;
    window.sessionStorage.removeItem(CART_STORAGE_KEY);
};

export const addItemToCart = (params) => {
    try {
        const { authorId, listingId, bookingDates, quantity = 1, timeZone, units = 1, selectedPackage, usageMultipleValues, otherOptionalFees, pickupAtOwnerLocation, returnAtOwnerLocation } = params;
        const { startDate, endDate } = bookingDates || {};
        if (
            !selectedPackage ||
            !startDate ||
            !endDate ||
            !listingId ||
            !authorId ||
            !timeZone ||
            !units
        ) {
            throw new Error('Required data is missing');
        }

        const cart = getCartFromSession() || [];

        const existingItemIndex = cart.findIndex(i => {
            const { startDate, endDate } = i.bookingDates;
            const { startDate: currentStart, endDate: currentEnd } = bookingDates;

            return (
                i.listingId === listingId &&
                moment(startDate).isSame(currentStart) &&
                moment(endDate).isSame(currentEnd) &&
                i.package === selectedPackage
            );
        });

        let updatedCart = [...cart];

        if (existingItemIndex !== -1) {
            updatedCart[existingItemIndex] = {
                ...updatedCart[existingItemIndex],
                quantity: Number(updatedCart[existingItemIndex].quantity || 1) + Number(quantity),
            };
        } else {
            updatedCart.push({
                id: uuidv4(),
                authorId,
                listingId,
                package: selectedPackage,
                bookingDates,
                quantity: Number(quantity),
                timeZone,
                units: Number(units),
                usageMultipleValues,
                otherOptionalFees,
                pickupAtOwnerLocation,
                returnAtOwnerLocation
            });
        }

        saveCartToSession(updatedCart);
        return updatedCart;
    } catch (error) {
        console.error('Error adding item to cart:', error);
        throw error;
    }
};

export const removeItemFromCart = (itemId) => {
    const cart = getCartFromSession() || [];
    const updatedCart = cart.filter(item => item.id !== itemId);
    saveCartToSession(updatedCart);
    return updatedCart;
};

export const saveBillingInfoToSession = (billingInfo) => {
    if (typeof window === 'undefined') return;
    window.sessionStorage.setItem(BILLING_INFO_STORAGE_KEY, JSON.stringify(billingInfo));
};


export const getBillingInfoFromSession = () => {
    if (typeof window === 'undefined') return null;
    const billingInfo = window.sessionStorage.getItem(BILLING_INFO_STORAGE_KEY);
    return billingInfo ? JSON.parse(billingInfo) : null;
};

export const clearBillingInfoFromSession = () => {
    if (typeof window === 'undefined') return;
    window.sessionStorage.removeItem(BILLING_INFO_STORAGE_KEY);
};